import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL; 

export const GET_CALLS_RECORD = `${API_URL}/api/v1/parent/activity`;
export const DELETE_CALLS = `${API_URL}/api/v1/parent/delete-activity`;

export function getCallRecord(payload){
    return axiosInstance({
        url: GET_CALLS_RECORD,
        method:"GET",
        params: payload
    })
}

export function deleteCalls(payload) {
    return axiosInstance({
        url: DELETE_CALLS,
        method: "put",
        data: payload
    })
}